var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        content: _vm.getExtensionOptionLabel(),
        placement: "top",
        delay: { show: 0, hide: 1 },
        disabled: _vm.disabled
      }
    },
    [
      _c("CompassIconButton", {
        attrs: {
          icon: _vm.getExtensionOptionIcon(),
          size: "small",
          disabled: _vm.disabled && _vm.loadingAttachment,
          active: _vm.activeStyle(_vm.option)
        },
        on: { click: _vm.selectFile }
      }),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file", multiple: "" },
        on: { change: _vm.handleFileChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }